import script from "./right_bar.vue?vue&type=script&setup=true&lang=js"
export * from "./right_bar.vue?vue&type=script&setup=true&lang=js"

export default script